import React, { useContext, useEffect, useState } from 'react';
import axiosInstance from '../../../configurations/axiosInstance/AxiosInstance';
import './listArticles.css';
import { useParams } from 'react-router-dom';
import HomeArticles from '../home/homeArticles';
import { LoadingContext } from '../../../composants/loadingContext';
import Loader from '../../../composants/loader/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper, faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';

const ListArticles = () => {
    const {loading, setLoading} = useContext(LoadingContext);
    const {name} = useParams();
    const [articles, setArticles] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredArticles, setFilteredArticles] = useState([]);
    
    const fetchArticle = async ()=>{
        setLoading(true); 
        try {
            let response = await axiosInstance().get('public/api/article/get-by-categorie/'+ name);
            let data = response.data;
            if (data) {
                setArticles(data);
                setFilteredArticles(data);
            } else {
                setArticles([]);
                setFilteredArticles([]);
            }
        } catch (error) {
            console.error('Error fetching articles:', error);
            setArticles([]);
            setFilteredArticles([]);
        }
        setLoading(false);
    }
    
    useEffect(() => {
        document.title = `Articles - ${name}`;
        fetchArticle();
    }, [name]);
    
    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredArticles(articles);
        } else {
            const filtered = articles.filter(article => 
                article.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                article.contenu?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredArticles(filtered);
        }
    }, [searchTerm, articles]);

    return (
        <>
            {loading && <Loader />}
            
            {/* Hero Section */}
            <div className="relative bg-gradient-to-br from-purple-600 via-pink-500 to-blue-500 text-white py-20 overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                </div>
                
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center animate__animated animate__fadeInDown">
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6 shadow-2xl">
                            <FontAwesomeIcon icon={faNewspaper} className="text-4xl" />
                        </div>
                        <h1 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight">
                            Explorez nos articles
                        </h1>
                        <div className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full">
                            <span className="text-lg font-semibold">{filteredArticles.length}</span>
                            <span className="text-white/80">article{filteredArticles.length > 1 ? 's' : ''} disponible{filteredArticles.length > 1 ? 's' : ''}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Search and Filters Section */}
            {articles.length > 0 && (
                <div className="bg-white shadow-sm border-b sticky top-0 z-10">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                        <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
                            {/* <div className="relative flex-1 max-w-md w-full">
                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                    <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Rechercher un article..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 shadow-sm hover:shadow-md"
                                />
                            </div> */}
                            
                            <div className="flex items-center gap-3">
                                <div className="px-4 py-2 bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg">
                                    <span className="text-sm font-medium text-purple-700">
                                        {filteredArticles.length} résultat{filteredArticles.length > 1 ? 's' : ''}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Articles Grid */}
            <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {filteredArticles.length === 0 && !loading ? (
                        <div className="text-center py-20">
                            <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full mb-6">
                                <FontAwesomeIcon icon={faNewspaper} className="text-5xl text-purple-500" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-3">
                                {searchTerm ? 'Aucun résultat trouvé' : 'Aucun article disponible'}
                            </h3>
                            <p className="text-gray-600 max-w-md mx-auto">
                                {searchTerm 
                                    ? `Aucun article ne correspond à "${searchTerm}". Essayez une autre recherche.`
                                    : 'Les articles seront bientôt disponibles dans cette catégorie.'}
                            </p>
                            {searchTerm && (
                                <button
                                    onClick={() => setSearchTerm('')}
                                    className="mt-6 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-xl font-medium hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
                                >
                                    Réinitialiser la recherche
                                </button>
                            )}
                        </div>
                    ) : (
                        <HomeArticles articles={filteredArticles} />
                    )}
                </div>
            </div>
        </>
    );
};

export default ListArticles;